"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _upsellUtils = require("../../utils/upsellUtils");
var _utils = require("../../utils/utils");
var _questionnaireActions = require("../questionnaire/questionnaireActions");
var _upsellActions = require("../upsell/upsellActions");
var _productCatalogActions = require("./productCatalogActions");
const initialState = {
  handsets: [],
  productRelationshipOffering: [],
  addresses: [],
  addressError: ''
};
const productCatalogReducer = function () {
  let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  let {
    type,
    payload
  } = arguments.length > 1 ? arguments[1] : undefined;
  switch (type) {
    case _productCatalogActions.SET_HANDSETS:
      return {
        ...state,
        handsets: payload.handsets
      };
    case _productCatalogActions.SET_PRODUCT_RELATIONSHIP_OFFERING:
      return {
        ...state,
        productRelationshipOffering: (0, _utils.uniquifyObjectsById)(payload.productOffering)
      };
    case _productCatalogActions.SET_PRODUCT_RELATIONSHIP_OFFERING_SELECTED_PRICE:
      return {
        ...state,
        productRelationshipOffering: state.productRelationshipOffering.map(offering => {
          var _payload$price, _payload$price2, _payload$price3, _payload$price4;
          return offering.id === payload.id && (_payload$price = payload.price) !== null && _payload$price !== void 0 && _payload$price.monthlyPrice && (_payload$price2 = payload.price) !== null && _payload$price2 !== void 0 && _payload$price2.monthlyPeriod && ((_payload$price3 = payload.price) !== null && _payload$price3 !== void 0 && _payload$price3.upfront || ((_payload$price4 = payload.price) === null || _payload$price4 === void 0 ? void 0 : _payload$price4.upfront) === 0) ? {
            ...offering,
            selectedPrice: payload.price,
            paymentOptions: (0, _upsellUtils.createPaymentOptions)(payload.price.monthlyPrice, payload.price.monthlyPeriod, payload.price.unit, payload.price.upfront)
          } : offering;
        })
      };
    case _upsellActions.UPDATE_SELECTED_UPSELL_VARIANT:
      {
        const newProductRelationshipOffering = state.productRelationshipOffering.map(offering => {
          if (offering.id === payload.productId) {
            offering.selectedVariant = payload.variant;
          }
          return offering;
        });
        return {
          ...state,
          productRelationshipOffering: newProductRelationshipOffering
        };
      }
    case _upsellActions.CLEAR_SELECTED_UPSELL_PRODUCT:
      {
        const newProductRelationshipOffering = state.productRelationshipOffering.map(offering => (0, _upsellUtils.resetOffering)(offering));
        return {
          ...state,
          productRelationshipOffering: newProductRelationshipOffering
        };
      }
    case _upsellActions.REMOVE_DISPLAYED_UPSELL_PRODUCT_DETAILS:
    case _upsellActions.REMOVE_SELECTED_UPSELL_PRODUCT:
      {
        const productRelationshipOffering = state.productRelationshipOffering.map(offering => {
          if (offering.id === payload.id) {
            return (0, _upsellUtils.resetOffering)(offering);
          }
          return offering;
        });
        return {
          ...state,
          productRelationshipOffering: productRelationshipOffering
        };
      }
    case _questionnaireActions.RESET_QUESTIONNAIRE:
      return {
        ...state,
        addresses: [],
        addressError: ''
      };
    case _productCatalogActions.FETCH_BROADBAND_ADDRESSES_SUCCESS:
      {
        return {
          ...state,
          addresses: payload.addresses,
          addressError: ''
        };
      }
    case _productCatalogActions.FETCH_BROADBAND_ADDRESSES_ERROR:
      return {
        ...state,
        addressError: payload.addressError,
        addresses: []
      };
    case _productCatalogActions.SET_PLAN_LOWEST_PRICE:
      return {
        ...state,
        lowestPlanPrice: payload.price
      };
    case _questionnaireActions.REMOVE_SELECTION:
    case _productCatalogActions.CLEAR_ADDRESSES:
      return {
        ...state,
        addresses: []
      };
    default:
      return state;
  }
};
var _default = productCatalogReducer;
exports.default = _default;